export default __webpack_public_path__ + "static/media/Benoit.834dde93.jpg";